<template>
  <div class="list">



<div class="list-group">
    <div class="row">
      <div class="col-md-12">
        <input class="form-control shadow" type="text" v-model="filter" placeholder="Gebruikers zoeken..." autofocus>

        <div class="form-check mt-3 text-md-right" v-if="filters">

          <label v-if="advancedSearch" class="checkbox-label">
            <input type="checkbox" class="form-check-input" id="UitgebreidZoeken" v-model="advanced">Uitgebreid zoeken
            <div class="checkbox-check"></div>
          </label>

        </div>

      </div>
      <div v-if="showTotal" class="col-1 text-right text-muted">
        {{ filterByAny(users,filter).length }} Resultaten
      </div>
    </div>

    <div class="px-4" v-if="advanced ">
      <hr class="my-4">
      <div class="col-12 col-lg-6 form-check" v-for="item in filters">

        <div class="d-flex align-items-centers">
          <label class="checkbox-label">
            <input type="checkbox" class="checkbox" v-model="selectedTags" :name="item" :value="item" :id="item">{{item}}
            <div class="checkbox-check"></div>
          </label>
        </div>


      </div>



      <div class="form-check mt-3" v-if="selectedTags.length >= 2 ">
        <hr>
        <label class="checkbox-label">
          <input type="checkbox" class="form-check-input" id="withAllTags" v-model="withAllTags">Selectie uitbreiden
          <div class="checkbox-check"></div>
        </label>
      </div>
    </div>
  </div>

  <div class="checkbox" v-if="filter.length >= 3" v-for=" user in filterByAny(users,filter)">

       <div class="px-3 my-2 border list-group-item">
         <label class="checkbox-label">
           <input id="checkbox"  type="checkbox" :value="user.Details.id" name="recipients[]" >  {{ user.Details.voornaam }} {{ user.Details.achternaam }}
           <div class="checkbox-check"></div>
         </label>
        </div>

  </div>


</div>


</template>
<script>
  export default {
    props: [
    'readurl',
        'advancedSearch',
        'showTotal'
    ],
    data() {
      return {
        users: [],
        filters: [],
        filter: '',
        advanced: false,
        selectedTags: [],
        withAllTags: false,
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      }
    },
    methods: {
   // Is niet nodig. Mogelijk in de toekomst wel.
   // filterBy: function(list, keyname, value) {
   //   return list.filter(function(item) {
   //     return item[keyname].toLowerCase().indexOf(value.toLowerCase()) > -1;
   //   });
   // },

 filterByAny: function(list, value) {

    if( ! list ) return [];

    return list.filter(function(item) {
      value = value.toLowerCase()
      var check = false;
      Object.keys(item.Details).forEach(function(keyname) {
        if (typeof(item.Details[keyname]) == 'string' && item.Details[keyname].toLowerCase().indexOf(value.toLowerCase()) > -1) {
          check = true;
        }
      })
      if (check === true) {
        return true;
      }
    });
  },

  loadUsers: function(){
    axios.post( '/endpoint/userdata', {'_token' : this.csrf    } ).then(function(data) {
      console.log('data', data.data);
      this.users = data.data.users
      this.filters = data.data.filters

    }.bind(this))
  },

  filterUsers: function( selection ){

    var params = {
      '_token' : this.csrf,  
      'selectedTags' : this.selectedTags,
      'withAllTags': this.withAllTags
    }
    axios.post( '/endpoint/userdata', params ).then(function(data) {
      // console.log('data', data.data);
      this.users = data.data.users
      // console.log(data.data.tags);
    }.bind(this)).catch(function (error) {
    // handle error
    console.log(error);
  })
  }
},
watch: {
  selectedTags(){
    this.filterUsers();
  },
  withAllTags(){
    this.filterUsers();
  },
  advanced(value){
    if( value === false ){
      this.selectedTags = [];
      this.withAllTags = false;
    }
  }
},
mounted: function() {
  this.loadUsers();
}};

</script>



// WEBPACK FOOTER //
// resources/js/components/UserIndexList.vue